<template>
  <div class="col-lg-12 col-sm-12">
    <table class="ir-loading-skeleton">
      <tbody>
        <tr>
          <th>
            <loading-skeleton type="block" style="height: 48px; width: 192px" />
          </th>
          <th>
            <loading-skeleton type="block" style="height: 39px; width: 524px" />
          </th>
        </tr>
        <tr>
          <td><loading-skeleton type="block" style="width: 95px" /></td>
          <td>
            <loading-skeleton type="block" style="height: 20px; width: 900px" />
          </td>
        </tr>
        <tr>
          <td><loading-skeleton type="block" style="width: 95px" /></td>
          <td>
            <loading-skeleton type="block" style="height: 20px; width: 900px" />
          </td>
        </tr>
        <tr>
          <td><loading-skeleton type="block" style="width: 95px" /></td>
          <td>
            <loading-skeleton type="block" style="height: 20px; width: 900px" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { LoadingSkeleton } from '@hypercodestudio/basler-components';
</script>

<style scoped>
.ir-loading-skeleton {
  width: 100%;
}
.ir-loading-skeleton tr th:first-child,
.ir-loading-skeleton tr td:first-child {
  width: 15%;
}
.ir-loading-skeleton tr th:last-child,
.ir-loading-skeleton tr td:last-child {
  width: 85%;
}
.ir-loading-skeleton tr th {
  padding: 1rem 0.75rem 2rem;
}
.ir-loading-skeleton tr td {
  padding: 1rem 0.75rem 1.5rem;
}
</style>
